import React, { createContext, useContext, useReducer } from 'react';
import { defaultTranscricaoState } from './defaultState';
import { transcricaoReducer } from './reducer';
import { TranscricaoAction, TranscricaoState } from './types';

interface TranscricaoContextType {
  state: TranscricaoState;
  dispatch: React.Dispatch<TranscricaoAction>;
}

const TranscricaoContext = createContext<TranscricaoContextType | undefined>(undefined);

export const TranscricaoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(transcricaoReducer, defaultTranscricaoState);

  return (
    <TranscricaoContext.Provider value={{ state, dispatch }}>
      {children}
    </TranscricaoContext.Provider>
  );
};

export const useTranscricao = () => {
  const context = useContext(TranscricaoContext);
  if (!context) {
    throw new Error('useTranscricao deve ser usado dentro de TranscricaoProvider');
  }
  return context;
};